import { Divider, Stack, Typography } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { ResourcesSelectorAccordion } from './resourcesSelector';

export const ResourceSelectionManualOverridesEditor = ({
  description,
  includeResources,
  excludeResources,
  setIncludedResources,
  setExcludedResources,
}: {
  description: string;
  includeResources: string[];
  excludeResources: string[];
  setIncludedResources: (includedResources: string[]) => void;
  setExcludedResources: (excludedResources: string[]) => void;
}) => {
  const dal = useDAL();
  const { data: allResources } = dal.inventory.listResourceIdentifiers();

  return (
    <Stack gap='32px' width='308px'>
      <Typography variant='h3'>Manual overrides</Typography>
      <Stack gap='24px' overflow='auto'>
        <Typography variant='body1'>{description}</Typography>
        <Stack gap='12px'>
          <ResourcesSelectorAccordion
            label='Included resources'
            description={`${includeResources.length} resources manually included${includeResources.length ? ':' : '.'}`}
            allResources={allResources?.resources ?? []}
            resources={includeResources}
            addResource={(resource) =>
              setIncludedResources([...includeResources, resource])
            }
            removeResource={(resource) =>
              setIncludedResources(
                includeResources.filter((r) => r !== resource)
              )
            }
          />
          <Divider />
          <ResourcesSelectorAccordion
            label='Excluded resources'
            description={`${excludeResources.length} resources manually excluded:`}
            allResources={allResources?.resources ?? []}
            resources={excludeResources}
            addResource={(resource) =>
              setExcludedResources([...excludeResources, resource])
            }
            removeResource={(resource) =>
              setExcludedResources(
                excludeResources.filter((r) => r !== resource)
              )
            }
          />
          <Divider />
        </Stack>
      </Stack>
    </Stack>
  );
};
